import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { Alert, Button, Loader, Modal, Typography, Toast } from '@refera/ui-web'
import { useDispatch, useSelector } from 'react-redux'

import { companySelector } from '_modules/company/selector'
import { updateCompany } from '_modules/company/actions'
import { financeOptionsSelector } from '_modules/finance/selectors'
import { getFinanceOptions } from '_modules/finance/actions'
import Select from '_components/common/select'

import useStyles from './styles'

const RequestTaxRegimeModal = ({ open, closeModal }) => {
  const styles = useStyles()
  const dispatch = useDispatch()
  const [selectedTax, setSelectedTax] = useState()
  const [toast, setToast] = useState({ isOpen: false, message: '', type: '' })
  const taxRegimeOptions = useSelector(financeOptionsSelector)?.taxRegimes
  const company = useSelector(companySelector)

  const [isLoading, setLoading] = useState(false)
  const [isLoadingFinanceOptions, setLoadingFinanceOptions] = useState(false)

  const selectOptions = useMemo(() => {
    if (!taxRegimeOptions?.length) {
      return null
    }

    return [{ value: '', label: 'Selecione' }, ...taxRegimeOptions]
  }, [taxRegimeOptions])

  const handleCloseToast = useCallback(() => {
    setToast(prevState => ({ ...prevState, isOpen: false }))
  }, [])

  const handleSelectChange = useCallback(event => {
    setSelectedTax(event.target.value)
  }, [])

  const handleSuccess = useCallback(() => {
    setToast({
      isOpen: true,
      message: 'Registro salvo com sucesso.',
      type: 'success',
    })
    closeModal()
  }, [closeModal])

  const handleError = useCallback(() => {
    setToast({
      isOpen: true,
      message: 'Ocorreu um erro ao salvar o registro.',
      type: 'error',
    })
  }, [])

  const handleSubmit = useCallback(() => {
    setLoading(true)
    dispatch(updateCompany(company.id, { taxRegime: selectedTax }))
      .then(() => handleSuccess())
      .catch(() => handleError())
      .finally(() => setLoading(false))
  }, [company.id, dispatch, selectedTax])

  useEffect(() => {
    if (!taxRegimeOptions.length && !isLoadingFinanceOptions) {
      setLoadingFinanceOptions(true)
      dispatch(getFinanceOptions()).then(() => setLoadingFinanceOptions(false))
    }
  }, [taxRegimeOptions])

  return (
    <>
      <Loader hasBackdrop open={isLoading} label="Aguarde..." />
      {open && (
        <Modal
          className={styles.modal}
          title="Atualização de cadastro"
          onBackdropClick={closeModal}
          onClose={closeModal}
          open={open}
          actionsButtons={
            <Grid className={styles.modalButtons}>
              <Button variant="ghost" onClick={closeModal}>
                Me lembre mais tarde
              </Button>
              <Button
                disabled={!selectedTax}
                color="primary"
                variant="primary"
                onClick={handleSubmit}
              >
                Confirmar
              </Button>
            </Grid>
          }
        >
          <Typography className={styles.textlabel}>
            Prestador, pedimos que informe os dados abaixo, para que possamos manter seu cadastro
            atualizado.
          </Typography>
          <Select
            label="Regime tributário"
            defaultValue=""
            value={selectedTax}
            onChange={handleSelectChange}
            options={selectOptions}
          />
        </Modal>
      )}
      {toast.isOpen && (
        <Toast draggable open={toast.isOpen} autoHideDuration={6000} onClose={handleCloseToast}>
          <Alert severity={toast.type} title={toast.message} onClose={handleCloseToast} />
        </Toast>
      )}
    </>
  )
}

RequestTaxRegimeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default RequestTaxRegimeModal
